import { TOKEN_NAME } from "./constants";

export async function request<TResponse>(
  url: string,
  config: RequestInit = {}
): Promise<TResponse> {
  return fetch(url, config)
    .then((response) => response.json())
    .then((data) => data as TResponse)
    .catch((data) => data);
}

export const api = {
  get: <TResponse>(url: string, config: RequestInit) =>
    request<TResponse>(url, config),

  post: <TResponse>(url: string, body: any) =>
    request<TResponse>(url, { method: "POST", body: JSON.stringify(body) }),
};

export const now = () => {
  return (
    new Date().toISOString().slice(0, 10) +
    " " +
    new Date().toLocaleTimeString("en-GB")
  );
};

export const getToken = () => {
  let token = localStorage.getItem(TOKEN_NAME);
  if (token != null) {
    token = JSON.parse(token);
  }
  return token;
};

export const setToken = (token: any) => {
  localStorage.setItem(TOKEN_NAME, JSON.stringify(token));
  return token;
};

export const removeToken = () => {
  localStorage.removeItem(TOKEN_NAME);
};

export const CONSTRUCTION = (self: any) => {
  self.$f7?.toast
    .create({
      text: "🚧 &nbsp;&nbsp;In Construction&nbsp;&nbsp; 🚧",
      position: "center",
      closeTimeout: 1500,
    })
    .open();
};



// WEBPACK FOOTER //
// ./src/utils/utils.ts